import React, { useEffect, useState } from 'react';
import { XIcon, SmartphoneIcon, ArrowRightIcon } from 'lucide-react';
interface AppDownloadBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}
export function AppDownloadBottomSheet({
  isOpen,
  onClose,
  onContinue
}: AppDownloadBottomSheetProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setIsVisible(true), 100);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };
  const handleContinue = () => {
    setIsVisible(false);
    setTimeout(onContinue, 300);
  };
  const handleDownload = () => {
    handleClose();
  };
  if (!isOpen) return null;
  return <>
      <div className={`fixed inset-0 bg-black transition-opacity duration-300 z-50 ${isVisible ? 'bg-opacity-50' : 'bg-opacity-0'}`} onClick={handleClose} data-id="element-3737" data-mp="1mtigyo48pc5s" />
      <div className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl z-50 transform transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} style={{
      paddingBottom: 'env(safe-area-inset-bottom)'
    }} data-id="element-3738" data-mp="19pskb8rlqtdp">
        <div className="flex justify-center pt-3 pb-2" data-id="element-3739" data-mp="10rgj6ct40d70">
          <div className="w-12 h-1 bg-gray-300 rounded-full" data-id="element-3740" data-mp="15mvw92jam52d" />
        </div>
        <div className="px-6 pb-6" data-id="element-3741" data-mp="qysrtxkwf1fo">
          <button onClick={handleClose} className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-3742" data-mp="qxrf7oo8i6vu">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-3743" data-mp="hzfe2spqrqp5" />
          </button>
          <div className="flex justify-center mb-4" data-id="element-3744" data-mp="m07pnsm367ol">
            <div className="w-20 h-20 bg-gradient-to-br from-[#1E2B55] to-[#162041] rounded-2xl flex items-center justify-center shadow-lg" data-id="element-3745" data-mp="m0r614w38o0i">
              <SmartphoneIcon className="w-10 h-10 text-white" data-id="element-3746" data-mp="czjjfk2xpbm9" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-2" data-id="element-3747" data-mp="2eop3befwur77">
            Get Our Mobile App
          </h2>
          <p className="text-gray-600 text-center mb-6" data-id="element-3748" data-mp="29xgtihao53ti">
            Download our app for a better shopping experience with exclusive
            deals and faster checkout
          </p>
          <div className="space-y-3" data-id="element-3749" data-mp="20xkb2xevh16w">
            <button onClick={handleDownload} className="w-full bg-gradient-to-r from-[#1E2B55] to-[#162041] text-white font-semibold py-4 rounded-xl hover:shadow-lg transition-all flex items-center justify-center gap-2" data-id="element-3750" data-mp="20ylmx43pprpo">
              <SmartphoneIcon className="w-5 h-5" data-id="element-3751" data-mp="2ommsc45lgs0v" />
              Download App
            </button>
            <button onClick={handleContinue} className="w-full bg-gray-100 text-gray-900 font-semibold py-4 rounded-xl hover:bg-gray-200 transition-all flex items-center justify-center gap-2" data-id="element-3752" data-mp="2jo1zipso9amg">
              Continue Browsing
              <ArrowRightIcon className="w-5 h-5" data-id="element-3753" data-mp="18apw2g0tqu0t" />
            </button>
          </div>
          <p className="text-xs text-gray-500 text-center mt-4" data-id="element-3754" data-mp="y6j7ddk4lq4a">
            Available on iOS and Android
          </p>
        </div>
      </div>
    </>;
}